import { CarouselBaseCard } from '@post-office/browser--growth-starburst/common/carouselBaseCard';

import {
	type CardImages,
	type CarouselCardProps,
} from '@post-office/browser--growth-starburst/common/carouselBaseCard/types';

import { commonTwcMessages } from '@post-office/browser--growth-starburst/common/constants';

import { defineMessages } from 'react-intl';

import { StudioCardIllustrationDark } from '../assets/StudioCardIllustrationDark';

import { StudioCardIllustrationLight } from '../assets/StudioCardIllustrationLight';

import { type JSX } from 'react/jsx-runtime';

export const StudioOnboardingCard = (props: CarouselCardProps): JSX.Element => {
	const images: CardImages = {
		component: <StudioCardIllustrationLight />,
		componentDark: <StudioCardIllustrationDark />,
	};
	return (
		<CarouselBaseCard
			messages={{ ...studioMessages, ...commonTwcMessages }}
			images={images}
			{...props}
		/>
	);
};

const studioMessages = defineMessages({
	heading: {
		defaultMessage: 'Automate work with Studio',
		description: 'Heading for the Studio onboarding card',
		id: 'townsquare.twc-onboarding-widget.studio-card.heading',
	},
	description: {
		defaultMessage: 'Build custom AI agents, automations, and more without needing to code.',
		description: 'Description for the Studio onboarding card',
		id: 'townsquare.twc-onboarding-widget.studio-card.description',
	},
	cta: {
		defaultMessage: 'Try Studio',
		description: 'Call to action text for the Studio onboarding card',
		id: 'townsquare.twc-onboarding-widget.studio-card.cta',
	},
});
